import React from 'react';
import 'twin.macro';
import { RatioIframe } from './';

const fbEmbedSize = {
  L: { width: '1020', height: '573' },
  XL: { width: '1175', height: '660' },
};

export const FacebookEmbed = ({ username, id }) => {
  return (
    <RatioIframe
      src={
        'https://www.facebook.com/plugins/video.php' +
        '?href=https%3A%2F%2Fwww.facebook.com%2F' +
        username +
        '%2Fvideos%2F' +
        id +
        '%2F&show_text=0&width=' +
        fbEmbedSize.L.width +
        '&height=' +
        fbEmbedSize.L.height
      }
    />
  );
};
